module.exports = __webpack_public_path__ + "static/920522262.f48edd60.jpg";